import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { FaHome, FaInfoCircle, FaServicestack, FaDownload, FaBriefcase, FaEnvelope } from 'react-icons/fa';
import './Top_Header.css';
import { Link } from 'react-router-dom';
// Add hover animation styles
const navLinkHoverStyle = `
.navbar-nav .nav-link {
    transition: color 0.3s, transform 0.3s;
}
.navbar-nav .nav-link:hover {
    color: #00d8ff !important;
    transform: translateY(-3px) scale(1.05);
    text-shadow: 0 2px 8px rgba(0,216,255,0.2);
}
`;

const styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerText = navLinkHoverStyle;
document.head.appendChild(styleSheet);
const TopHeader = () => (
    <nav
        className="navbar navbar-expand-lg navbar-light fixed-top"
        style={{ backgroundColor: 'rgb(34, 34, 34)', color:'white', paddingTop: '16px', paddingBottom: '16px' }}
    >
        <div className="container-fluid">
            <img src='minix-logo.png' alt='logo' style={{width: 'auto', height: '40px', marginRight: '10px'}}/> 
    
            <a className="navbar-brand" href="#" style={{ color: 'white' }}>MINIX IT HUB Pvt. Ltd.</a>
            <button
                className="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarNav"
                aria-controls="navbarNav"
                aria-expanded="false"
                aria-label="Toggle navigation"
                style={{ borderColor: 'white' }}
            >
                <span className="navbar-toggler-icon" style={{ filter: 'invert(1)' }}></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarNav">
                <ul className="navbar-nav ms-auto">
                    <li className="nav-item">
                        <a className="nav-link active" href="/Home" style={{ color: 'white', display: 'flex', alignItems: 'center' }}>
                            <FaHome style={{ marginRight: '6px' }} /> Home
                        </a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link" href="/about" style={{ color: 'white', display: 'flex', alignItems: 'center' }}>
                            <FaInfoCircle style={{ marginRight: '6px' }} /> About us
                        </a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link" href="/services" style={{ color: 'white', display: 'flex', alignItems: 'center' }}>
                            <FaServicestack style={{ marginRight: '6px' }} /> Services
                        </a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link" href="/Download" style={{ color: 'white', display: 'flex', alignItems: 'center' }}>
                            <FaDownload style={{ marginRight: '6px' }} /> Download
                        </a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link" href="/portfolio" style={{ color: 'white', display: 'flex', alignItems: 'center' }}>
                            <FaBriefcase style={{ marginRight: '6px' }} /> Portfolio
                        </a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link" href="/contact" style={{ color: 'white', display: 'flex', alignItems: 'center' }}>
                            <FaEnvelope style={{ marginRight: '6px' }} /> Contact us
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
);

export default TopHeader;